var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
/**
 * List component of widget list
 *
 * @param param0
 */
export function EtcWidgetList() {
    return (_jsx(_Fragment, { children: _jsxs("span", __assign({ className: "flex flex-row items-center" }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-4 h-4" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5l-3.9 19.5m-2.1-19.5l-3.9 19.5" }) })), _jsx("span", __assign({ className: "ml-2" }, { children: "WIDGET LIST" }))] })) }));
}
layoutComponentsDictionary.registerLayoutComponent("etc-widget-list", EtcWidgetList);
